module.exports = __webpack_public_path__ + "media/pick_axe01.9ef54b5b.mp3";